import NewsCert from '../styles/images/news_cert.png';
import NewsDonation from '../styles/images/news_donation.png';
import NewsMain00Sto from '../styles/images/news_main_00_sto.png';
import NewsMain00 from '../styles/images/news_main_00.png';
import NewsMain01 from '../styles/images/news_main_01.png';
import NewsMain02 from '../styles/images/news_main_02.png';
import NewsMain03 from '../styles/images/news_main_03.png';
import NewsMain04 from '../styles/images/news_main_04.png';
import NewsMain05 from '../styles/images/news_main_05.png';
import NewsMain06 from '../styles/images/news_main_06.png';
import NewsOther00 from '../styles/images/news_other_00.png';
// import NewsOther01 from '../styles/images/news_other_01.png';
import NewsOther02 from '../styles/images/news_other_02.png';
import NewsOther03 from '../styles/images/news_other_03.png';
import NewsOther04 from '../styles/images/news_other_04.png';
import NewsOther05 from '../styles/images/news_other_05.png';
import NewsOther06 from '../styles/images/news_other_06.png';
// import NewsOther07 from '../styles/images/news_other_07.png';
import NewsOther08 from '../styles/images/news_other_08.png';

/* 뉴스 */
export const MAIN_NEWS = '주요 뉴스';
export const OTHER_NEWS = '그 외 뉴스';

export const NEWS_MAIN_LIST = [
  {
    title: "NH투자증권, 토큰증권 협의체 'STO 비전그룹' 출범",
    img: NewsMain00Sto,
    link: 'https://www.hankyung.com/finance/article/2023022080346',
    press: '한국경제',
    date: '2023.02.20',
  },
  {
    title: '팝플, 한국형 자발적 탄소 크레딧 거래 박차',
    img: NewsDonation,
    link: 'https://news.mt.co.kr/mtview.php?no=2022120614121568953',
    press: '머니투데이',
    date: '2022.12.06',
  },
  {
    title: '그리너리-넥스트, 재생에너지 시장 활성화를 위한 업무협약 체결',
    img: NewsMain00,
    link: 'https://www.mk.co.kr/news/it/10519779',
    press: '매일경제',
    date: '2022.11.07',
  },
  {
    title: '[인터뷰] 탄소중립이 문화가 되는 날을 꿈꾸다',
    img: NewsMain01,
    link: 'https://www.dongascience.com/news.php?idx=56664',
    press: '동아사이언스',
    date: '2022.10.15',
  },
  {
    title: '탄소 감축, 의무시장만으론 역부족..자발감축 동원해야',
    img: NewsMain02,
    link: 'https://news.mt.co.kr/mtview.php?no=2022071314113416462&outlink=1&ref=%3A%2F%2F',
    press: '머니투데이',
    date: '2022.07.14',
  },
  // {
  //   title: '환경재단, 탄소감축 크레딧 솔루션 그리너리와 협약',
  //   img: NewsMain03,
  //   link: 'http://www.e-platform.net/news/articleView.html?idxno=73353',
  //   press: '에너지플랫폼뉴스',
  //   date: '2022.06.07',
  // },
  {
    title: "[르포] 앙코르와트 누비는 태양광 전기 오토바이..탄소 크레딧은 '덤'",
    img: NewsMain04,
    link: 'https://biz.chosun.com/stock/stock_general/2022/05/30/MWKNL4DQPFHRBKXRP2567Y4LVM/',
    press: '조선비즈',
    date: '2022.05.30',
  },
  {
    title: '탄소중립 자발적 참여..플랫폼서 즐겁게 해보세요',
    img: NewsMain05,
    link: 'https://www.mk.co.kr/news/business/view/2022/05/462779/',
    press: '매일경제',
    date: '2022.05.25',
  },
  {
    title: "모빌리티 코인 '두굿(DoGood)' 발행 컨소시엄 발족",
    img: NewsMain06,
    link: 'https://www.mk.co.kr/news/business/view/2022/03/268770/',
    press: '매일경제',
    date: '2022.03.24',
  },
  // {
  //   title: "에이투엠, 그리너리와 탄소 크레딧 발행·거래 시스템 구축",
  //   img: NewsOther00,
  //   link: 'https://m.etnews.com/20221101000115',
  //   press: '전자신문',
  //   date: '2022.11.01',
  // },
];

export const NEWS_OTHER_LIST = [
  // {
  //   title: '에이투엠, 그리너리와 탄소 크레딧 발행·거래 시스템 구축',
  //   img: NewsOther00,
  //   link: 'https://m.etnews.com/20221101000115',
  //   desc: '에이투엠(대표 김정우)이 탄소 크레딧 발행 및 거래 시스템 구축에 나섰다. 에이투엠은 그리너리와 신재생에너지 설비유지보수(O&M) 플랫폼 기반 탄소 크레딧 발행 및 거래 활성화 추진을 위한 업무협약을 체결했다고 1일 밝혔다. 협약에 따라 신재생에너지 발전을 통해 발생하는 탄소 크레딧 및 REC(재생에너지 증명)를 대상으로 인증서 발행 및 유통 활성을 위한 협업 관계를 이어나갈 예정이다. 에이투엠이 개발한 신재생에너지 O&M 플랫폼(byWIND)과 그리너리의 자발적 탄소 거래 플랫폼(POPLE) 시스템 간 크레딧 발행을 위한 자동 연계 체계 구축을 목표로, 탄소 중립의 글로벌 기조에 발맞추고자 뜻을 모았다.',
  //   press: '전자신문',
  //   date: '2022.11.01',
  // },
  {
    title: "환경 지킴이 '인증서'로 돈 벌게 해주는 남자",
    img: NewsCert,
    link: 'http://news.heraldcorp.com/view.php?ud=20220718000417',
    desc: '‘지구와 미래 세대를 위해 이렇게 노력했는데.... 과연 누가 알아주기나 할까? 실제 도움이 되기는 할까?’ 친환경 활동에 동참한다면 누구나 피할 수 없는 질문이다. 출근길에 자가용 대신 대중교통을 이용하고 일회용품 배달 대신 다회용기 포장을 선택하는 번거로움을 감내해도, 본인과 가족 외엔 그 노력을 알아주기 힘들다. 굳이 남들에게 인정받을 필요는 없지만, 이 노력이 지구에 얼마나 도움이 됐는지조차 알 수 없으니 답답한 노릇이다.',
    press: '헤럴드경제',
    date: '2022.07.18',
  },
  {
    title: "2030 '탄소 중립' 달성하려면 자발적 탄소시장 동반돼야",
    img: NewsOther02,
    link: 'https://news.mt.co.kr/mtview.php?no=2022071409385397085&outlink=1&ref=%3A%2F%2F',
    desc: "\"지금까지는 의무 탄소시장만으로 5~10% 탄소를 감축할 수 있었지만 '넷 제로'(탄소 중립)로 가기 위해선 자발적 감축 노력이 필요하다.\" 황유식 그리너리 공동대표는 14일 '국내 산업 생태계 전반의 지속가능 경영 역량 제고방안 모색'이라는 주제로 서울 소공동 웨스틴조선호텔에서 열린 'ESG 쇼케이스 2022'에서 이같이 말했다. 그리너리는 자발적 탄소 인증·거래 플랫폼 '팝플'(POPLE)을 운영하고 있다.",
    press: '머니투데이',
    date: '2022.07.14',
  },
  {
    title: '환경재단·그리너리, 탄소감축 크레딧 본격 거래	',
    img: NewsOther03,
    link: 'http://www.todayenergy.kr/news/articleView.html?idxno=248977',
    desc: '[투데이에너지 송명규 기자] 기후환경문제 해결을 위한 공익재단인 환경재단(이사장 최열)은 자발적 탄소시장 활성화를 위해 7일 그리너리와 MOU를 체결했다. 이번 업무협약을 통해 환경재단과 그리너리는 탄소감축을 위해 탄소감축량을 정확하게 측정하고 감축량에 크레딧을 부여해 민간 플랫폼에서 거래할 계획이다. 이번 업무협약은 시민들에게 탄소중립에 대한 정확한 정보를 전파하고 더 많은 기업들과 시민들의 참여를 유도해 탄소중립 시대를 앞당기기 위해 마련됐다. 그리너리는 탄소중립을 위한 솔루션을 제공하는 기업으로 국내 최초의 자발적 탄소 감축크레딧 거래 플랫폼인 ‘팝플(POPLE)’을 개발 및 운영하고 있다. ‘팝플’을 통해 기업과 개인이 탄소 중립을 실현할 수 있는 수단, 컨설팅 서비스 등을 제공한다.',
    press: '투데이에너지',
    date: '2022.06.07',
  },
  {
    title: '전기 오토바이로 관광하면 탄소 크레딧이 차곡차곡	',
    img: NewsOther04,
    link: 'https://www.hankyung.com/economy/article/2022052998301',
    desc: '캄보디아의 세계적 문화유산 앙코르와트. 이곳 관광의 백미는 사원 사이를 오가는 전기 오토바이 라이딩이다. 태양광 배터리로 충전한 전기 오토바이로 관광을 즐기면서 탄소 배출량 저감에도 기여할 수 있다. 오토바이가 하루 30㎞를 달린다고 가정하면 매일 대당 1.5㎏의 탄소 배출을 줄일 수 있다. 전기 오토바이로 줄인 탄소 배출량은 ‘탄소 크레딧’으로 쌓이고, 이를 기업 등이 자유롭게 구매할 수 있다.',
    press: '한국경제',
    date: '2022.05.29',
  },
  {
    title: '국내 기업, 자발적 탄소시장 사업에 앞다퉈 진출	',
    img: NewsOther05,
    link: 'http://www.ekoreanews.co.kr/news/articleView.html?idxno=60470',
    desc: '[이코리아] 전 세계 환경 규제 강화와 투자자들의 ESG 인식 제고에 따라 자발적 탄소시장(Voluntary Carbon Market)이 꾸준한 성장세를 보일 것으로 전망된다. 최근 국내 기업들도 앞 다퉈 자발적 탄소시장과 관련된 사업에 진출하고 있는 만큼 이에 대한 꾸준한 관심이 요구된다. 자발적 탄소시장은 기업이나 NGO 등의 단체가 자발적인 탄소 감축 프로젝트를 실행하고 특정 국가나 유엔이 아닌 제 3자기관의 승인을 얻어 온실가스 상쇄 크레딧을 획득하는 시장을 일컫는다.',
    press: '이코리아',
    date: '2022.04.27',
  },
  {
    title: '그리너리, 블록체인 탄소 거래소 오픈..ESG계의 비트코인 되나	',
    img: NewsOther06,
    link: 'https://news.mt.co.kr/mtview.php?no=2022042108450643666&outlink=1&ref=%3A%2F%2F',
    desc: '최근 ESG(환경, 사회적책임, 투명경영) 생태계에는 많은 변화가 있었다. 수년전만 해도 ESG의 개념조차 생소해하던 기업들이 이제는 최고경영자(CEO) 직속 ESG조직을 만들고 경영철학과 비전에도 이를 반영하고 있다. ESG는 세계 정치경제 사회이슈에서 빠지지 않는 의제가 됐으며 일반 소비자들에게도 익숙한 단어가 됐다. 양적 팽창도 눈에 띈다. 글로벌 ESG채권 시장규모는 지난해 약 1000조원에 달해 2015년 대비 20배 성장했고',
    press: '머니투데이',
    date: '2022.04.22',
  },
  // {
  //   title: '탄소중립 위해 뭉친 모빌리티 스타트업, 두굿 컨소시엄 발족',
  //   img: NewsOther07,
  //   link: 'https://news.mt.co.kr/mtview.php?no=2022032413220848670&outlink=1&ref=%3A%2F%2F',
  //   desc: "다양한 이동수단 서비스를 제공하는 국내 모빌리티 스타트업들이 탄소배출 감축을 목표로 하는 모빌리티 코인 '두굿(DoGood)' 발행을 위한 두굿 컨소시엄을 구성했다고 24일 밝혔다. 지난 23일 인터콘티넨탈 서울 코엑스 호텔에서 발족식을 가진 두굿 컨소시엄은 모빌리티 관련 스타트업 카모아, 코나투스, 알파카, 베리워즈 4개사와 더불어 블록체인 전문기업 람다256, 자발적 탄소배출 거래플랫폼 '팝플'",
  //   press: '머니투데이',
  //   date: '2022.03.24',
  // },
];
